import { render, staticRenderFns } from "./PropositionItems.vue?vue&type=template&id=a054354e&scoped=true&"
import script from "./PropositionItems.vue?vue&type=script&lang=js&"
export * from "./PropositionItems.vue?vue&type=script&lang=js&"
import style0 from "./PropositionItems.vue?vue&type=style&index=0&id=a054354e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a054354e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VTextarea})
